import { Box, Skeleton } from '@mui/material';

const Loader: React.FC<{ rows?: number }> = ({ rows }) => {
  return (
    <Box>
      <Skeleton variant="rectangular" height={100} width="100%" />
      {[...Array(rows ?? 5)].map((item, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
          <Skeleton variant="rectangular" height={100} width="10%" />
          <Skeleton variant="rectangular" height={100} width="30%" />
          <Skeleton variant="rectangular" height={100} width="30%" />
          <Skeleton variant="rectangular" height={100} width="20%" />
          <Skeleton variant="rectangular" height={100} width="10%" />
        </Box>
      ))}
      <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '8px', justifyContent: 'space-between' }}>
        <Skeleton variant="rectangular" height={50} width={50} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px', marginTop: '8px' }}>
          <Skeleton variant="rectangular" height={30} width={30} />
          <Skeleton variant="rectangular" height={30} width={30} />
          <Skeleton variant="rectangular" height={30} width={30} />
          <Skeleton variant="rectangular" height={30} width={30} />
          <Skeleton variant="rectangular" height={30} width={30} />
        </Box>
        <Skeleton variant="rectangular" height={50} width={50} />
      </Box>
    </Box>
  );
};

export default Loader;
